import { render, staticRenderFns } from "./workflowHrGiftsTable.vue?vue&type=template&id=489431d8"
import script from "./workflowHrGiftsTable.vue?vue&type=script&lang=js"
export * from "./workflowHrGiftsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports